if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
            refreshCartProgress();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/* Free shipping progress bar */

const BLOCKED_COUNTRIES = ['GB', 'MC', 'CH', 'CA', 'US', 'AU', 'NZ']; // UK, Monaco, etc.

function shouldHideFreeShippingProgress() {
  const currentCountry = Shopify.country || ''; // e.g., 'GB'
  return BLOCKED_COUNTRIES.includes(currentCountry);
}

const FREE_SHIPPING_THRESHOLDS = {
  SEK: 150000,   // 1500.00 SEK
  NOK: 180000,   // 1800.00 NOK
  EUR: 15000     // 150.00 EUR
};

const CURRENCY_SYMBOLS = {
  SEK: 'SEK',
  NOK: 'NOK',
  EUR: '€'
};

function getFreeShippingMessage(remainingFormatted) {
  const locale = Shopify.locale || 'en';

  switch (locale) {
    case 'sv':
      return `Du är ${remainingFormatted} från fri frakt!`;
    case 'de':
      return `Du bist ${remainingFormatted} vom kostenlosen Versand entfernt!`;
    case 'en':
    default:
      return `You're ${remainingFormatted} away from free shipping!`;
  }
}

function getFreeShippingUnlockedMessage() {
  const locale = Shopify.locale || 'en';

  switch (locale) {
    case 'sv':
      return `Du har låst upp fri frakt!`;
    case 'de':
      return `Du hast kostenlosen Versand freigeschaltet!`;
    case 'en':
    default:
      return `You've unlocked free shipping!`;
  }
}

function getCurrentCurrency() {
  return Shopify.currency?.active || 'SEK'; // Default to SEK if undefined
}

function updateFreeShippingProgress(cartTotal) {
  const container = document.querySelector('.free-shipping-progress');
  if (shouldHideFreeShippingProgress()) {
    if (container) container.style.display = 'none';
    return;
  } else {
    if (container) container.style.display = 'block';
  }
  const fill = document.querySelector('.progress-bar-fill');
  const text = document.querySelector('.progress-text');

  if (!fill || !text) return;

  const currency = getCurrentCurrency();
  const threshold = FREE_SHIPPING_THRESHOLDS[currency] || FREE_SHIPPING_THRESHOLDS['SEK'];
  const symbol = CURRENCY_SYMBOLS[currency] || '';

  const remaining = threshold - cartTotal;
  const percentage = Math.min(100, (cartTotal / threshold) * 100);

  fill.style.width = `${percentage}%`;

  const remainingFormatted = `${symbol}${(remaining / 100).toFixed(2)}`;
  text.textContent = remaining > 0
    ? getFreeShippingMessage(remainingFormatted)
    : getFreeShippingUnlockedMessage();
}

function refreshCartProgress() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      updateFreeShippingProgress(cart.total_price);
    })
    .catch(error => {
      console.error('Failed to refresh free shipping progress:', error);
    });
}

